export const TRANSLATIONS_JP_HOME_DECISION_DETAIL = {
  "home.decisionDetail.eyebrow": "詳細",
  "home.decisionDetail.title": "決定の詳細",
  "home.decisionDetail.close": "詳細を閉じる",
  "home.decisionDetail.whyLabel": "重要な理由",
  "home.decisionDetail.state": "状態",
  "home.decisionDetail.owner": "担当者",
  "home.decisionDetail.dueAt": "期限",
  "home.decisionDetail.priority": "優先度",
  "home.decisionDetail.notAvailable": "利用可能なデータなし",
  "home.decisionDetail.risk": "リスク",
  "home.decisionDetail.confidence": "信頼度",
  "home.decisionDetail.evidence": "根拠",
  "home.decisionDetail.missingInformation": "不足情報",
  "home.decisionDetail.noReason": "理由はありません。",
  "home.decisionDetail.sourceTrace": "ソーストレース",
  "home.decisionDetail.historyPreview": "最近の履歴",
  "home.decisionDetail.documents": "関連ドキュメント",
  "home.decisionDetail.actionArea": "アクション領域",
  "home.decisionDetail.noActionAvailable": "利用可能なアクションはまだありません。",
  "home.decisionDetail.actionAreaCopy": "この決定についてまず何をすべきか、Home IA からの提案です。",
  "home.decisionDetail.actionDisabled": "このアクションは現在有効ではありません。",
  "home.decisionDetail.actionNeedsForm": "このアクションの実行には追加入力が必要です。",
  "home.decisionDetail.trace.traceId": "Trace ID",
  "home.decisionDetail.trace.actionSource": "アクションソース",
  "home.decisionDetail.trace.confidenceSource": "信頼度ソース",
  "home.decisionDetail.trace.explanationSource": "説明ソース",
  "home.decisionDetail.trace.evaluatorVersion": "評価器バージョン",
  "home.decisionDetail.trace.rulesVersion": "ルールバージョン",
  "home.decisionDetail.trace.actionSourceDetail": "アクションソース詳細",
  "home.decisionDetail.trace.confidenceSourceDetail": "信頼度ソース詳細",
  "home.decisionDetail.trace.explanationSourceDetail": "説明ソース詳細",
  "home.decisionDetail.trace.catalogHealthAtEvaluation": "評価時のカタログ状態",
  "home.decisionDetail.technical.show": "技術的トレースを見る",
  "home.decisionDetail.technical.hide": "技術的トレースを隠す",
  "home.decisionDetail.technical.copy": "サポート、デバッグ、高度な確認に役立つ項目を含みます。",
  "home.decisionDetail.technicalField.score": "スコア",
  "home.decisionDetail.technicalField.tier": "階層",
  "home.decisionDetail.technicalField.final_reason": "最終理由",
  "home.decisionDetail.technicalField.base": "基礎値",
  "home.decisionDetail.technicalField.urgency": "緊急度",
  "home.decisionDetail.technicalField.date_proximity": "日付の近さ",
  "home.decisionDetail.technicalField.risk_boost": "リスク補正",
  "home.decisionDetail.technicalField.artifact_boost": "証跡補正",
  "home.decisionDetail.technicalField.user_state_adjustment": "ユーザー状態調整",
  "home.decisionDetail.technicalField.level": "レベル",
  "home.decisionDetail.technicalField.category": "カテゴリ",
  "home.decisionDetail.technicalField.reason": "理由",
  "home.decisionDetail.technicalField.impact_areas": "影響領域",
  "home.decisionDetail.technicalField.escalation_triggers": "エスカレーショントリガー",
  "home.decisionDetail.technicalField.evidence_ids": "証跡ID",
  "home.decisionDetail.technicalField.overall": "総合",
  "home.decisionDetail.technicalField.classification": "分類",
  "home.decisionDetail.technicalField.date_extraction": "日付抽出",
  "home.decisionDetail.technicalField.action_selection": "アクション選択",
  "home.decisionDetail.technicalField.explanation": "説明",
  "home.decisionDetail.technicalField.warnings": "警告",
  "home.decisionDetail.evidenceLabel.dateWithField": "日付: {field}",
  "home.decisionDetail.inspectHint": "これはアクションを実行しません。この詳細内で確認すべきセクションに移動するだけです。",
  "home.decisionDetail.inspectCta.missing": "不足情報へ移動",
  "home.decisionDetail.inspectCta.evidence": "根拠へ移動",
  "home.decisionDetail.inspectCta.technical": "技術的トレースへ移動",
  "home.decisionDetail.inspectCta.generic": "確認セクションへ移動",
  "home.decisionDetail.missingLocation": "どこで修正するか",
  "home.decisionDetail.missingExternal": "この情報は Home IA 内では入力しません。元のドキュメントまたは元システムで修正する必要があります。",
  "home.decisionDetail.missingNextStep": "この情報を補完すると、Home IA は意思決定を再計算できます。その後、この意思決定をもう一度確認してください。",
  "home.decisionDetail.missingLocation.documentOrigin": "元ドキュメント",
  "home.decisionDetail.missingLocation.systemOrigin": "元システム",
  "home.decisionDetail.missingLocation.classification": "分類",
  "home.decisionDetail.missingLocation.manualReview": "手動確認",
  "home.decisionDetail.missingLocation.undetermined": "未特定",
  "home.decisionDetail.missingLocationCopy.documentOrigin": "Home IA が再度検出できるよう、元ドキュメントで修正する必要があります。",
  "home.decisionDetail.missingLocationCopy.systemOrigin": "この意思決定を再計算する前に、元システムで更新する必要があります。",
  "home.decisionDetail.missingLocationCopy.classification": "この意思決定の元になる分類または抽出で確認する必要があります。",
  "home.decisionDetail.missingLocationCopy.manualReview": "不足データを確認または補完するために手動確認が必要です。",
  "home.decisionDetail.missingLocationCopy.undetermined": "現在の情報では、どこで修正すべきかを特定できません。",
  "home.decisionDetail.actionFailedTitle": "アクションを実行できませんでした",
  "home.decisionDetail.actionFailedCopy": "利用可能なデータでは決定を更新できませんでした。",
  "home.decisionDetail.actionSuccess": "決定は正常に更新されました。",
  "home.decisionDetail.actionUnavailable": "この決定では現在このアクションを利用できません。",
  "home.decisionDetail.availableActions": "利用可能なアクション",
  "home.decisionDetail.availableActionsCopy": "自分のペースでこの決定を扱えます。誰かに割り当てる、保留する、解決済みにする、または見送ることができます。",
  "home.decisionDetail.moreActions": "その他のアクション",
  "home.decisionDetail.remediationActions": "是正アクション",
  "home.decisionDetail.dangerActions": "慎重に扱うアクション",
  "home.decisionDetail.unavailableActions": "利用できないアクション",
  "home.decisionDetail.actionResult.stateChanged": "決定の状態が変更されました。",
  "home.decisionDetail.actionResult.businessAcknowledged": "業務アクションは受理されましたが、下流システムでの確認待ちです。",
  "home.decisionDetail.actionResult.manualBusinessCompletion": "決定は手動で完了しました。",
  "home.decisionDetail.actionResult.reevaluationQueued": "再評価がキューに入りました。新しい結果が届くと Home IA がこの決定を更新します。",
  "home.decisionDetail.actionResult.inspectionOnly": "レビューは完了しましたが、運用上の状態変更はまだ適用されていません。",
  "home.decisionDetail.actionResult.rejected": "アクションは拒否されたか、より新しいサーバー状態と競合しました。",
  "home.decisionDetail.actionResult.replay": "このアクションは既に適用されていました。Home IA は前回の結果を再利用しました。",
  "home.decisionDetail.actor.system": "システム",
  "home.decisionDetail.actor.user": "ユーザー",
  "home.decisionDetail.evidenceType.artifact_type": "文書タイプ",
  "home.decisionDetail.evidenceType.detected_date": "検出日付",
  "home.decisionDetail.evidenceType.role_classification": "業務ロール",
  "home.decisionDetail.source.db_catalog_mapping": "カタログルール",
  "home.decisionDetail.source.learned_pattern": "学習済みパターン",
  "home.decisionDetail.source.semantic_classifier": "意味分類器",
  "home.decisionDetail.source.keyword_rule": "キーワードルール",
  "home.decisionDetail.source.deterministic_rule_default": "決定論ルール（既定値）",
  "home.decisionDetail.source.model_score": "モデルスコア",
  "home.decisionDetail.source.user_override": "手動調整",
  "home.decisionDetail.source.fallback": "信頼できるソースなし",
  "home.decisionDetail.source.rule_explanation": "ルール説明",
  "home.decisionDetail.role.compliance_deadline": "コンプライアンス期限",
  "home.decisionDetail.role.invoice_due": "請求期限",
  "home.decisionDetail.enum.invoice": "請求書",
  "home.decisionDetail.enum.period_start": "期間開始日",
  "home.decisionDetail.enum.period_end": "期間終了日",
  "home.decisionDetail.enum.issue_date": "発行日",
  "home.decisionDetail.enum.payment_date": "支払日",
  "home.decisionDetail.enum.event_date": "イベント日",
  "home.decisionDetail.enum.utility_bill": "公共料金請求書",
  "home.decisionDetail.enum.payment": "支払い",
  "home.decisionDetail.enum.tax_declaration": "税務申告",
  "home.decisionDetail.enum.tax": "税金",
  "home.decisionDetail.enum.compliance": "コンプライアンス",
  "home.decisionDetail.enum.task": "タスク",
  "home.decisionDetail.enum.action_item": "対応項目",
  "home.decisionDetail.enum.receipt": "受領書",
  "home.decisionDetail.enum.critical": "重大",
  "home.decisionDetail.enum.high": "高",
  "home.decisionDetail.enum.medium": "中",
  "home.decisionDetail.enum.low": "低",
  "home.decisionDetail.enum.financial": "財務",
  "home.decisionDetail.enum.operational": "運用",
  "home.decisionDetail.enum.billing": "請求管理",
  "home.decisionDetail.enum.cash_flow": "キャッシュフロー",
  "home.decisionDetail.enum.vendor_relations": "取引先関係",
  "home.decisionDetail.enum.due_date": "期限日",
  "home.decisionDetail.enum.overdue_deadline": "期限超過",
  "home.decisionDetail.enum.potential_penalty_or_late_fee": "遅延損害金または延滞料の可能性",
  "home.decisionDetail.enum.critical_risk_level": "重大リスクレベル",
  "home.decisionDetail.enum.escalation_to_management_required": "管理者へのエスカレーションが必要",
  "home.decisionDetail.action.label.review_proposal": "提案を確認する",
  "home.decisionDetail.action.label.acknowledge": "確認済みにする",
  "home.decisionDetail.action.label.assign": "担当者を割り当てる",
  "home.decisionDetail.action.label.snooze": "延期する",
  "home.decisionDetail.action.label.postpone": "延期する",
  "home.decisionDetail.action.label.mark_waiting": "待機中にする",
  "home.decisionDetail.action.label.mark_blocked": "ブロック中にする",
  "home.decisionDetail.action.label.complete": "完了にする",
  "home.decisionDetail.action.label.resolve": "解決する",
  "home.decisionDetail.action.label.dismiss": "破棄する",
  "home.decisionDetail.action.label.discard": "破棄する",
  "home.decisionDetail.action.label.reevaluate": "再評価する",
  "home.decisionDetail.action.label.verify_compliance": "コンプライアンスを確認する",
  "home.decisionDetail.action.label.process_payment": "支払いを処理する",
  "home.decisionDetail.action.description.review_proposal": "下流の業務ステップを確定する前に、このケースに対して Home IA が提案した内容を確認します。",
  "home.decisionDetail.action.description.acknowledge": "状態を変えずに、確認済みであることを記録します。",
  "home.decisionDetail.action.description.assign": "ケースに明確な担当者がつくよう、この決定のフォロー責任を特定の人へ移します。",
  "home.decisionDetail.action.description.snooze": "適切な緊急度で再表示されるよう、この決定を限られた日数だけ一時的に延期します。",
  "home.decisionDetail.action.description.postpone": "適切な緊急度で再表示されるよう、この決定を限られた日数だけ一時的に延期します。",
  "home.decisionDetail.action.description.mark_waiting": "外部依存を待っている間、この決定を開いたままにします。",
  "home.decisionDetail.action.description.mark_blocked": "阻害要因が解消されるまで、この決定をブロック状態にします。",
  "home.decisionDetail.action.description.complete": "対応が済んだら解決済みにします。メモを追加できます。",
  "home.decisionDetail.action.description.resolve": "根本原因が対処された後、この決定を解決済みにします。",
  "home.decisionDetail.action.description.dismiss": "この決定を運用上は破棄可能と記録します。文書や決定履歴を削除するわけではありません。",
  "home.decisionDetail.action.description.discard": "この決定を運用上は破棄可能と記録します。文書や決定履歴を削除するわけではありません。",
  "home.decisionDetail.action.description.reevaluate": "最新の文脈でこの決定を再処理し、必要に応じて分類修正やレビュー情報を追加できるようにします。",
  "home.decisionDetail.action.complete.confirmLabel": "必要な対応が完了しており、この決定を完了として閉じてよいことを確認します。",
  "home.decisionDetail.action.discard.confirmLabel": "この決定に即時の運用対応は不要であることを確認します。",
  "home.decisionDetail.action.reevaluate.confirmLabel": "この決定を最新の文脈で再評価すべきことを確認します。",
  "home.decisionDetail.action.description.verify_compliance": "コンプライアンス作業を確認し、完了証跡を記録します。",
  "home.decisionDetail.action.description.process_payment": "支払いを記録し、決定の状態を更新します。",
  "home.decisionDetail.action.criteria.verify_compliance.0": "コンプライアンス確認を完了してください。",
  "home.decisionDetail.action.criteria.verify_compliance.1": "関連する文書または証跡を添付してください。",
  "home.decisionDetail.action.criteria.process_payment.0": "支払いを完了として記録してください。",
  "home.decisionDetail.action.criteria.process_payment.1": "支払い証跡または取引参照を添付してください。",
  "home.decisionDetail.actionField.notes.label": "メモ",
  "home.decisionDetail.actionField.days.label": "延期する日数",
  "home.decisionDetail.actionField.days.placeholder": "3",
  "home.decisionDetail.actionField.waiting_until.label": "待機期限",
  "home.decisionDetail.actionField.snoozed_until.label": "延期期限",
  "home.decisionDetail.actionField.assigned_to_user_id.label": "担当者",
  "home.decisionDetail.actionField.blocked_reason.label": "ブロック理由",
  "home.decisionDetail.actionField.completion_evidence.label": "完了証跡",
  "home.decisionDetail.actionField.reason.label": "理由",
  "home.decisionDetail.actionField.corrected_artifact_type.label": "修正後のアーティファクト種別",
  "home.decisionDetail.actionField.correction_reason.label": "修正理由",
  "home.decisionDetail.actionField.correction_notes.label": "修正メモ",
  "home.decisionDetail.actionField.document_text_snippet.label": "補足テキスト抜粋",
  "home.decisionDetail.actionField.counterparty.label": "取引先",
  "home.decisionDetail.action.assign.field.assigned_to_user_id.helper": "誰がフォローを引き受けるかを指定します。これはケースを閉じません。",
  "home.decisionDetail.action.assign.field.assigned_to_user_id.placeholder": "user123 または owner@company.com",
  "home.decisionDetail.action.assign.field.reason.helper": "任意。担当を移す理由を説明します。",
  "home.decisionDetail.action.assign.field.notes.helper": "任意。新しい担当者向けに文脈や次の手順を残します。",
  "home.decisionDetail.action.postpone.field.days.helper": "任意の日付ではなく、日数で延期します。",
  "home.decisionDetail.action.postpone.field.reason.helper": "任意。後で再表示させたい理由を説明します。",
  "home.decisionDetail.action.postpone.field.notes.helper": "任意。次回レビューのための補足を残します。",
  "home.decisionDetail.action.complete.field.completion_evidence.helper": "任意。証跡、参照、または構造化された完了データを添付します。",
  "home.decisionDetail.action.complete.field.notes.helper": "任意。完了した内容を要約します。",
  "home.decisionDetail.action.discard.field.reason.helper": "任意。なぜ実務上の対応が不要なのかを説明します。",
  "home.decisionDetail.action.discard.field.notes.helper": "任意。将来の確認者向けにメモを残します。",
  "home.decisionDetail.action.reevaluate.field.reason.helper": "なぜ Home IA がこの決定を再計算すべきかを説明します。",
  "home.decisionDetail.action.reevaluate.field.corrected_artifact_type.helper": "任意。元の分類が誤っていた場合は正しい種別を選びます。",
  "home.decisionDetail.action.reevaluate.field.correction_reason.helper": "任意。分類の問題や欠けていた文脈を説明します。",
  "home.decisionDetail.action.reevaluate.field.correction_notes.helper": "任意。再処理向けの追加メモを残します。",
  "home.decisionDetail.action.reevaluate.field.document_text_snippet.helper": "任意。修正を裏づける関連抜粋を入力します。",
  "home.decisionDetail.history.type.decision_evaluated": "決定が評価されました",
  "home.decisionDetail.history.type.decision_acknowledged": "決定が確認されました",
  "home.decisionDetail.history.type.decision_assigned": "決定が割り当てられました",
  "home.decisionDetail.history.type.decision_snoozed": "決定が延期されました",
  "home.decisionDetail.history.type.decision_waiting": "決定が待機中になりました",
  "home.decisionDetail.history.type.decision_blocked": "決定がブロックされました",
  "home.decisionDetail.history.type.decision_completed": "決定が完了しました",
  "home.decisionDetail.history.type.decision_resolved": "決定が解決しました",
  "home.decisionDetail.history.type.decision_dismissed": "決定が不要として閉じられました",
  "home.decisionDetail.history.type.decision_reopened": "決定が再開されました",
  "home.decisionDetail.history.type.decision_info_provided": "追加情報が提供されました",
  "home.decisionDetail.history.type.decision_state_changed": "状態が変更されました",
  "home.decisionDetail.history.narrative.decision_evaluated": "{actor} がこの決定を評価し、状態を {state} にしました。",
  "home.decisionDetail.history.narrative.decision_acknowledged": "{actor} がこの決定を確認しました。",
  "home.decisionDetail.history.narrative.decision_assigned": "{actor} がこの決定を割り当てました。",
  "home.decisionDetail.history.narrative.decision_snoozed": "{actor} がこの決定を延期しました。",
  "home.decisionDetail.history.narrative.decision_waiting": "{actor} がこの決定を待機中にしました。",
  "home.decisionDetail.history.narrative.decision_blocked": "{actor} がこの決定をブロック中にしました。",
  "home.decisionDetail.history.narrative.decision_completed": "{actor} がこの決定を完了しました。",
  "home.decisionDetail.history.narrative.decision_resolved": "{actor} がこの決定を解決しました。",
  "home.decisionDetail.history.narrative.decision_dismissed": "{actor} がこの決定を不要として閉じました。",
  "home.decisionDetail.history.narrative.decision_reopened": "{actor} がこの決定を再開しました。",
  "home.decisionDetail.history.narrative.decision_info_provided": "{actor} が追加情報を提供しました。",
  "home.decisionDetail.history.narrative.decision_state_changed": "この決定は {state} に変わりました。",
  "home.decisionDetail.dynamic.pattern.action_disabled_in_state": "このアクションは {state} 状態では使えません。",
  "home.decisionDetail.dynamic.copy.decision_is_in_active_window_with_critical_risk": "この決定はアクション期間中で、重大なリスクがあります。",
  "home.decisionDetail.dynamic.copy.decision_is_in_active_window_with_high_risk": "この決定はアクション期間中で、高いリスクがあります。",
  "home.decisionDetail.dynamic.copy.decision_is_overdue": "この決定は期限超過です。",
  "home.decisionDetail.dynamic.copy.decision_is_approaching_its_action_window": "この決定はアクション期間に近づいています。",
  "home.decisionDetail.dynamic.copy.decision_is_waiting_for_an_external_dependency": "この決定は外部依存を待っています。",
  "home.decisionDetail.dynamic.copy.counterparty_is_required_before_processing": "処理前に取引先情報が必要です。",
  "home.decisionDetail.dynamic.copy.confidence_is_below_the_execution_threshold": "信頼度が実行しきい値を下回っています。",
  "home.decisionDetail.dynamic.copy.required_catalog_action_is_unavailable": "必要なカタログアクションを利用できません。",
  "home.decisionDetail.dynamic.copy.decision_is_blocked_resolve_blocking_conditions_first": "この決定はブロックされています。先にブロック条件を解消してください。",
  "home.decisionDetail.dynamic.copy.action_could_not_be_determined_with_sufficient_confidence": "十分な信頼度でアクションを特定できませんでした。",
  "home.decisionDetail.dynamic.copy.critical_risk_for_invoice_payment_this_item_is_overdue_immediate_attention_required_to_avoid_severe_business_or_regulatory_impact": "請求書の支払いに重大なリスクがあります。この項目は期限超過です。重大な業務上または規制上の影響を避けるため、直ちに対応が必要です。",
  "home.decisionDetail.dynamic.copy.confidence_source_is_deterministic_rule_default_value_is_a_non_model_default": "信頼度ソースは 'deterministic_rule_default' であり、この値はモデル由来ではない既定値です。",
  "home.decisionDetail.dynamic.copy.critical_priority_overdue_escalation_applied_urgency_boost_25_artifact_boost_5": "重大優先度。期限超過エスカレーションを適用。緊急度補正: +25。証跡補正: +5。",
};
